import {
  compactFormat,
  dimension,
  dimensionSelector,
  granularity,
  legendPosition,
  palette,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME],
  name: "streamChart",
  title: "Stream Chart",
  defaultHeight: 6,
  controls: [{ ...dimension, metricName: "decompositionMetricTop" }, granularity],
  settings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric (Horizontal Axis)",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric (Vertical Axis)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (Stream)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [2, 0],
      tooltipOrder: 0,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "displayMetric",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
  },
  planSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric (Horizontal Axis)",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric (Vertical Axis)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (Stream)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [2, 0],
      tooltipOrder: 0,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "displayMetric",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
  },
  planExploreSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },

    decompositionMetric: {
      default: "month",
      type: "select",
      label: "Decomposition Metric (Horizontal Axis)",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 1,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric (Vertical Axis)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    decompositionMetricTop: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (Stream)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [2, 0],
      tooltipOrder: 0,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "decompositionMetric",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "displayMetric",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
  },
};
